import ApiV1 from "@/configs/axios/ApiV1";

export function GetDownloadsCount() {
  return ApiV1.get("/downloads/count");
}

export function GetDownloadsByStatus(status, params = {}) {
  return ApiV1.get(`/downloads/${status}`, { params });
}
